import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function FailedSolutions() {
  const failures = [{
    title: 'Gomitas de Melatonina',
    desc: 'Inundan tu cerebro con dosis sintéticas 50 veces superiores a lo natural, creando una dependencia química peligrosa.'
  }, {
    title: 'Aceites de CBD',
    desc: 'Suelen ser parches temporales que no atacan la causa raíz biológica: la temperatura y los fotones.'
  }, {
    title: 'Poner la mente en blanco',
    desc: 'Es imposible si tu cuerpo tiene una temperatura interna demasiado elevada para entrar en la fase de sueño profundo.'
  }, {
    title: 'Pastillas Recetadas',
    desc: 'Te dejan inconsciente, pero bloquean el sueño REM, eliminando la fase donde realmente se limpia tu cerebro.'
  }];
  return <section className="py-10 px-4 md:px-8 bg-[#0f1628]/40" data-id="element-32">
      <div className="max-w-5xl mx-auto" data-id="element-33">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-34">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-35">
            Por qué lo que has probado no funciona
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-36">
          {failures.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} viewport={{
          once: true
        }} className="flex items-start gap-4 bg-[#0f1628]/50 border border-slate-600/30 p-6 rounded-xl hover:border-slate-500/40 transition-colors" data-id="element-37">
              <XCircle className="w-6 h-6 text-rose-400 shrink-0 mt-1" data-id="element-38" />
              <div data-id="element-39">
                <h3 className="text-lg font-bold text-white mb-2" data-id="element-40">
                  {item.title}
                </h3>
                <p className="text-[#b8c4d6] leading-relaxed" data-id="element-41">{item.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}